export const secureStorageAddresses = [
    { address: "0x039987486206d32aB55BE53c2748121a6559aAdE", chainId: "1" },
    { address: "0x4FEe9fc300DFF6221e5911f296c4CaA3d23A7830", chainId: "5" },
    { address: "0xF71396c6F168Dc1c213AA9433cB0E7C1e4B07964", chainId: "11155111" },
];
//# sourceMappingURL=constants.js.map